<template>
<div>
  <hb-modal v-model="dialog" size="medium" title="Warning!" show-help-link confirmation>
    <template v-slot:content>
        <div class="px-6 py-4">
            Gate Code by Text should only be enabled in your auto-attendant when ID verification is enabled and mandatory in Maripossa. Enabling this feature without enforcing ID verification may result in unauthorized access by unverified tenants. For assistance or more information, contact Tenant Inc Customer Support.       
        </div>
    </template> 
    <template v-slot:actions>
        <hb-btn color="primary"  @click="$emit('confirm-charm', true)">I Understand</hb-btn>
    </template>
  </hb-modal>
</div>
</template>

<script type="text/babel">
  export default {
    name: "CharmEnableConfirmation",
    data() {
      return {};
    },
    props: {
      value:{
        type: Boolean,
        default: false
      },
    },
    computed: {
      dialog: {
          get () {
            return this.value
          },
          set (value) {
            this.$emit('input', value)
            if (!value) {
                this.$emit('close');
            }
          }
      },
    }
  }

</script>

<style type="scss" scoped></style>